import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AgentProvider } from "./context/AgentContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/Home";
import AgentHomePage from "./pages/AgentHome";
import AgentLoginPage from "./pages/AgentLogin";
import ReferrerLoginPage from "./pages/ReferrerLogin";
import InsurancePage from "./pages/Insurance";
import InvestmentPage from "./pages/Investment";
import MortgagePage from "./pages/Mortgage";
import TeamPage from "./pages/Team";
import AboutPage from "./pages/About";
import WhatWeDoPage from "./pages/WhatWeDo";
import CoreValuesPage from "./pages/CoreValues";
import WhyChooseUsPage from "./pages/WhyChooseUs";
import PartnersPage from "./pages/Partners";
import ResourcesPage from "./pages/Resources";
import CreditCounsellingPage from "./pages/CreditCounsellingRedirect";
import ContactPage from "./pages/Contact";
import AdminDashboard from "./pages/Admin";
import VATracker from "./pages/VATracker";
import SignDocument from "./pages/SignDocument";
import ClientUpload from "./pages/ClientUpload";
import ClientIntake from "./pages/ClientIntake";
import BlogPage from "./pages/Blog";
import BlogPostPage from "./pages/BlogPost";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";
import TermsOfUsePage from "./pages/TermsOfUse";
import ComplaintHandlingPage from "./pages/ComplaintHandling";
import LicensingDisclosurePage from "./pages/LicensingDisclosure";

// ScrollToTop component - scrolls to top on route change
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash (e.g., #quote), scroll to that element
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      // Otherwise scroll to top
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <AgentProvider>
            <ScrollToTop />
            <Header />
            <Routes>
              {/* Main Routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/insurance" element={<InsurancePage />} />
              <Route path="/investment" element={<InvestmentPage />} />
              <Route path="/mortgage" element={<MortgagePage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/what-we-do" element={<WhatWeDoPage />} />
              <Route path="/core-values" element={<CoreValuesPage />} />
              <Route path="/why-choose-us" element={<WhyChooseUsPage />} />
              <Route path="/partners" element={<PartnersPage />} />
              <Route path="/resources" element={<ResourcesPage />} />
              <Route path="/credit-counselling" element={<CreditCounsellingPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/time-tracker" element={<VATracker />} />
              <Route path="/sign/:token" element={<SignDocument />} />
              <Route path="/intake/:token" element={<ClientIntake />} />
              <Route path="/client-upload/:token" element={<ClientUpload />} />
              <Route path="/agent-login" element={<AgentLoginPage />} />
              <Route path="/referrer-login" element={<ReferrerLoginPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms-of-use" element={<TermsOfUsePage />} />
              <Route path="/complaint-handling" element={<ComplaintHandlingPage />} />
              <Route path="/licensing-disclosure" element={<LicensingDisclosurePage />} />
              
              {/* Agent Sub-Website Routes */}
              <Route path="/agent/:agentSlug" element={<AgentHomePage />} />
              <Route path="/agent/:agentSlug/insurance" element={<InsurancePage />} />
              <Route path="/agent/:agentSlug/investment" element={<InvestmentPage />} />
              <Route path="/agent/:agentSlug/mortgage" element={<MortgagePage />} />
              <Route path="/agent/:agentSlug/team" element={<TeamPage />} />
              <Route path="/agent/:agentSlug/partners" element={<PartnersPage />} />
              <Route path="/agent/:agentSlug/resources" element={<ResourcesPage />} />
              <Route path="/agent/:agentSlug/contact" element={<ContactPage />} />
              <Route path="/agent/:agentSlug/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/agent/:agentSlug/terms-of-use" element={<TermsOfUsePage />} />
              <Route path="/agent/:agentSlug/complaint-handling" element={<ComplaintHandlingPage />} />
              <Route path="/agent/:agentSlug/licensing-disclosure" element={<LicensingDisclosurePage />} />
            </Routes>
            <Footer />
          </AgentProvider>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
